import { useMemo } from 'react';

import {
  DEFAULT_ACADEMIC_YEAR_FILTER_SETTINGS,
  PageSettingsKey
} from 'shared/constants/pageSettings';
import { useGetFormattedSettings } from 'shared/hooks/useGetFormattedSettings';

export const usePageFilterSettings = (pageKey: PageSettingsKey) => {
  const { data } = useGetFormattedSettings();

  return useMemo(() => {
    const academicYear =
      data?.visual?.pageSettings?.[pageKey]?.filtersSettings?.academicYearsFilterSettings ??
      DEFAULT_ACADEMIC_YEAR_FILTER_SETTINGS;

    return {
      isAcademicYearEnabled: academicYear.allowUserToChangeDropdownValue,
      showAllAcademicYearOption: academicYear.showAllOption,
      shouldForceAllAcademicYear:
        !academicYear.allowUserToChangeDropdownValue && academicYear.showAllOption
    };
  }, [data?.visual?.pageSettings, pageKey]);
};
